import * as Yup from 'yup'
import { checkVAT, countries } from 'jsvat'
import { t } from 'i18n'

export const objectWithId = Yup.object().shape({
  id: Yup.string().required()
})

export const vatNumber = Yup.string().test('validVatNumber', t('activerecord.errors.messages.invalid_vat_number'), (vatNumber: string) => {
  if (vatNumber) {
    return checkVAT(vatNumber, countries).isValid === true
  } else {
    return true
  }
})
